import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=1b78dc71&scoped=true&"
import script from "./QuickActions.vue?vue&type=script&lang=js&"
export * from "./QuickActions.vue?vue&type=script&lang=js&"
import style0 from "./QuickActions.vue?vue&type=style&index=0&id=1b78dc71&prod&scoped=true&lang=css&"
import style1 from "./QuickActions.vue?vue&type=style&index=1&id=1b78dc71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b78dc71",
  null
  
)

export default component.exports